import { render, staticRenderFns } from "./ResumenPago.vue?vue&type=template&id=614b54b5&"
import script from "./ResumenPago.vue?vue&type=script&lang=js&"
export * from "./ResumenPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports